import style from "../../assets/scss/common/header.module.scss";
import loginIcon from "../../assets/images/header/login_icon.svg";
import React, {useEffect, useRef, useState} from "react";
import {useAppDispatch, useAuth, useAwardBanner, useLanguage, useModal, useUserAgent} from "../../hooks/hooks";
import {ModalType} from "../../types/common";
import {useClickEvent} from "../../hooks/useClickEvent";
import {useUserInfoGetter} from "./hooks/useUserInfoGetter";
import {useVoucherStore} from "./hooks/voucherStore";
import {LoggedInStatusBar} from "./hooks/LoggedInStatusBar";
import {HeaderLinkField} from "../HeaderLinkField";
import {useTranslation} from "react-i18next";

interface Props {
  signOut: VoidFunction;
}
export function LoginBar({ signOut }: Props) {
  const dispatch = useAppDispatch();
  const voucherStore = useVoucherStore();
  const { t } = useTranslation("loginBar");

  const [isCouponVoucherCollapsed, setIsCouponVoucherCollapsed] = useState(true);
  const { hideAwardBanner, setHideAwardBanner } = useAwardBanner();
  const { isKorean } = useLanguage();
  const { isLoggedIn } = useAuth();
  const { openModal } = useModal();
  const { isDesktop, isTablet, isMobile } = useUserAgent();
  const { getUserInfo, user } = useUserInfoGetter();
  const awardBannerDesc = isMobile
      ? 'K-PASS 지능검사에 열정적인 사랑을 보내주신 모든 분들께 감사드리며,앞으로도 우리 아이들을 위해 대한민국 최고의 디지털 두뇌 지능검사 서비스를 제공해 드릴 것을 약속드립니다.'
      : 'K-PASS 지능검사에 열정적인 사랑을 보내주신 모든 분들께 감사드리며,\n앞으로도 우리 아이들을 위해 대한민국 최고의 디지털 두뇌 지능검사 서비스를 제공해 드릴 것을 약속드립니다.'

  const {
    userVoucherCount,
    organVoucherCount,
    organKpassVoucherCount,
    consultingVoucherCount,
    couponCount,
    fetchAllVoucherCounts
  } = useVoucherStore();

  useEffect(() => {
    voucherStore.setDispatch(dispatch)
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn) {
      if (!user) {
        getUserInfo().then();
      }
      fetchAllVoucherCounts().then();
    }
    // eslint-disable-next-line
  }, [isLoggedIn]);

  const onClickLoginBtn = (e: React.MouseEvent) => {
    openModal(ModalType.LOGIN);
    e.stopPropagation();
  };

  const isBannerVisible = isDesktop && isKorean && !hideAwardBanner;
  const onClickLogoutBtn = () => signOut();

  useEffect(() => {}, [hideAwardBanner]);
  useEffect(() => {}, [isTablet, isMobile]);

  // "오늘 하루 그만 보기" 버튼 클릭 시 호출
  const handleNotTodayClick = () => {
    setHideAwardBanner(true);
    const now = new Date();
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    localStorage.setItem("hideAwardBanner", "true");
    localStorage.setItem("hideBannerExpiry", tomorrow.getTime().toString());
  };

  const LoginBtn = () => (
      <div className={style.loginBarWrapper}>
        <div className={style.loginBar}>
          <HeaderLinkField />
          <div className={style.innerBar}>
            <button className={style.loginBtn} onClick={onClickLoginBtn}>
              <img className={style.icon} src={loginIcon} alt="login-icon" />
              <span className={style.text}>{t("btn.loginAndSignup")}</span>
            </button>
          </div>
        </div>
      </div>
  );

  const couponVoucherOptionsRef = useRef(null);
  useClickEvent({ elementRefs: [couponVoucherOptionsRef], doOnClickBg: () => setIsCouponVoucherCollapsed(true) });

  const LoggedInContent = () => (
      <div className={style.loginBarWrapper}>
        <LoggedInStatusBar
            user={user}
            couponCount={couponCount} organVoucherCount={organVoucherCount}
            consultingVoucherCount={consultingVoucherCount} organKpassVoucherCount={organKpassVoucherCount}
            userVoucherCount={userVoucherCount} isCouponVoucherCollapsed={isCouponVoucherCollapsed}
            setIsCouponVoucherCollapsed={setIsCouponVoucherCollapsed}
            couponVoucherOptionsRef={couponVoucherOptionsRef}
            onClickLogoutBtn={() => onClickLogoutBtn()}/>
      </div>
  );

  // 브라우저 width값 계산
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (
      <>
        {isLoggedIn ? <LoggedInContent/> : <LoginBtn/>}
        {isBannerVisible && (
            <div className={style.brandBannerBox}>
              <div className={style.brandBannerFrame} onClick={handleNotTodayClick}>
                <div className={style.bannerContainer}>
                  <div className={windowWidth <=1960 ? style.backgroundWrapper : style.backgroundUpperWrapper}>
                    <div className={style.brandBackground1}/>
                  </div>
                  {/*  트로피  */}
                  <div className={style.brandTrophyContainer}>
                    <div className={style.brandBackground2}/>
                    <div className={style.brandTrophy}/>
                  </div>

                  {/*  문구  */}
                  <div className={style.brandDescContainer}>
                    <div className={style.brandDescWrapper}>
                      <div className={style.brandDescTitle}>
                        <p className={style.bracket}>[ 2025 소비자가 뽑은 가장 신뢰하는 브랜드 대상 ]</p>
                        <span className={style.bold}>K-PASS 디지털 두뇌 지능검사</span>
                        가{isMobile && '\n'} 선정 되었습니다!

                      </div>
                      <div className={style.brandDescTitle}>
                        {awardBannerDesc}
                      </div>
                    </div>
                  </div>

                  {/*  오늘 하루 그만보기  */}
                  <div className={style.notTodayContainer}>
                    <div className={style.xIcon}/>
                    <div className={style.notTodayText}>
                      오늘 하루 그만 보기
                    </div>
                  </div>
                </div>
              </div>
            </div>
        )}
      </>
  );
}
